<template>
  <div class="orderContact">
    <v-order :meal="meal" :form="form" :way="way" :additional="additional"></v-order>
    <div class="contactForm">
      <el-form
        :label-position="labelPosition"
        label-width="100px"
        :model="form"
        :rules="rules"
        ref="ruleForm"
        size="mini"
      >
        <div class="form-item">
          <el-form-item label="顧客名稱：" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </div>
        <div class="form-item">
          <el-form-item label="Email：" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
        </div>
        <div class="form-item">
          <el-form-item label="聯絡電話：" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
        </div>
        <div class="form-item">
          <el-form-item label="後備電話：" prop="backphone">
            <el-input v-model="form.backphone"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import order from "./order.vue";
export default {
  props: ["meal","way", "form","additional"],
  components: {
    "v-order": order,
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      labelPosition: "left",
      rules: {
        name: [
          {
            required: true,
            message: "请输入名稱",
            trigger: blur,
          },
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        phone: [{ validator: checkPhone, trigger: "blur",required: true }],
        backphone: [{ validator: checkPhone, trigger: "blur",required: true }],
      },
    };
  },
  methods: {
    //子组件校验，传递到父组件
    validateForm() {
      let flag = null;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          flag = true;
        } else {
          flag = false;
        }
      });
      return flag;
    },
  },
  mounted(){
  }
};
</script>
<style scoped>
.orderContact {
  padding: 0.25rem 0.5rem;
}
.contactForm {
  margin: 0.6rem 0;
}
</style>
